import './style/index.js';

import _Space from './space';

export type { TdSpaceProps } from './type';

export const Space = _Space;

export default Space;
